import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Landmark, Loader2, ArrowLeft, MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() }); } catch (err) {}
    setSent(true); setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-11 w-11 rounded-xl brand-gradient flex items-center justify-center">
            <Landmark className="h-5 w-5 text-emerald-300" />
          </div>
          <p className="font-bold text-brand" style={{ fontFamily: "Outfit" }}>EXTRA TRUSS FINANCE</p>
        </div>
        {sent ? (
          <div data-testid="forgot-success" className="text-center">
            <div className="h-14 w-14 rounded-2xl bg-emerald-100 flex items-center justify-center mx-auto mb-4">
              <MailCheck className="h-7 w-7 text-brand" />
            </div>
            <h1 className="text-xl font-bold" style={{ fontFamily: "Outfit" }}>Cek email Anda</h1>
            <p className="text-sm text-muted-foreground mt-2">Jika email terdaftar, tautan reset password telah dikirim. Tautan berlaku 1 jam.</p>
            <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-brand hover:underline mt-6">
              <ArrowLeft className="h-4 w-4" /> Kembali ke halaman masuk
            </Link>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-bold" style={{ fontFamily: "Outfit" }}>Lupa Password</h1>
            <p className="text-sm text-muted-foreground mt-1 mb-6">Masukkan email Anda untuk menerima tautan reset.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" data-testid="forgot-email-input" value={email}
                  onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" />
              </div>
              <Button type="submit" data-testid="forgot-submit-btn" disabled={loading} className="w-full bg-brand hover:bg-emerald-800 h-11">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Kirim Tautan Reset"}
              </Button>
            </form>
            <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-brand hover:underline mt-6">
              <ArrowLeft className="h-4 w-4" /> Kembali ke halaman masuk
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
